package linkerpangoquipdb

import app.cash.sqldelight.ExecutableQuery
import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class SparePartQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> select_by_id(id: Long, mapper: (
    id: Long,
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    signature: String?,
    reference: String?,
  ) -> T): Query<T> = Select_by_idQuery(id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun select_by_id(id: Long): Query<Spare_part> = select_by_id(id, ::Spare_part)

  public fun <T : Any> select_by_server_id(server_id: Long?, mapper: (
    id: Long,
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    signature: String?,
    reference: String?,
  ) -> T): Query<T> = Select_by_server_idQuery(server_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun select_by_server_id(server_id: Long?): Query<Spare_part> = select_by_server_id(server_id, ::Spare_part)

  public fun <T : Any> select_by_category(category_id: String, mapper: (
    id: Long,
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    signature: String?,
    reference: String?,
  ) -> T): Query<T> = Select_by_categoryQuery(category_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun select_by_category(category_id: String): Query<Spare_part> = select_by_category(category_id, ::Spare_part)

  public fun <T : Any> select_by_spare_part_id(spare_part_id: String, mapper: (
    id: Long,
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    signature: String?,
    reference: String?,
  ) -> T): Query<T> = Select_by_spare_part_idQuery(spare_part_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun select_by_spare_part_id(spare_part_id: String): Query<Spare_part> = select_by_spare_part_id(spare_part_id, ::Spare_part)

  public fun <T : Any> select_all(mapper: (
    id: Long,
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    signature: String?,
    reference: String?,
  ) -> T): Query<T> = Query(-1_003_990_429, arrayOf("spare_part"), driver, "SparePart.sq", "select_all", "SELECT spare_part.id, spare_part.server_id, spare_part.category_id, spare_part.spare_part_id, spare_part.brand, spare_part.model, spare_part.additional_info, spare_part.durability_days, spare_part.quantity, spare_part.unit, spare_part.signature, spare_part.reference FROM spare_part") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun select_all(): Query<Spare_part> = select_all(::Spare_part)

  public fun last_insert_rowid(): ExecutableQuery<Long> = Query(-611_178_413, driver, "SparePart.sq", "last_insert_rowid", "SELECT last_insert_rowid()") { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> select_latest_by_category_and_type_for_vehicle(
    vehicle_vin: String,
    category_id: String,
    spare_part_id: String,
    mapper: (
      id: Long,
      server_id: Long?,
      category_id: String,
      spare_part_id: String,
      brand: String,
      model: String,
      additional_info: String,
      durability_days: Long?,
      quantity: Double?,
      unit: String?,
      signature: String?,
      reference: String?,
    ) -> T,
  ): Query<T> = Select_latest_by_category_and_type_for_vehicleQuery(vehicle_vin, category_id, spare_part_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7),
      cursor.getDouble(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11)
    )
  }

  public fun select_latest_by_category_and_type_for_vehicle(
    vehicle_vin: String,
    category_id: String,
    spare_part_id: String,
  ): Query<Spare_part> = select_latest_by_category_and_type_for_vehicle(vehicle_vin, category_id, spare_part_id, ::Spare_part)

  public fun select_distinct_brands_by_type(vehicle_type: String): Query<String> = Select_distinct_brands_by_typeQuery(vehicle_type) { cursor ->
    cursor.getString(0)!!
  }

  public fun select_distinct_models_by_type(vehicle_type: String): Query<String> = Select_distinct_models_by_typeQuery(vehicle_type) { cursor ->
    cursor.getString(0)!!
  }

  public fun select_distinct_brands(): Query<String> = Query(670_049_841, arrayOf("spare_part"), driver, "SparePart.sq", "select_distinct_brands", "SELECT DISTINCT brand FROM spare_part WHERE brand != '' ORDER BY brand ASC") { cursor ->
    cursor.getString(0)!!
  }

  public fun select_distinct_models(): Query<String> = Query(982_280_911, arrayOf("spare_part"), driver, "SparePart.sq", "select_distinct_models", "SELECT DISTINCT model FROM spare_part WHERE model != '' ORDER BY model ASC") { cursor ->
    cursor.getString(0)!!
  }

  public fun select_distinct_durability_days(): Query<Long> = Query(2_058_406_920, arrayOf("spare_part"), driver, "SparePart.sq", "select_distinct_durability_days", "SELECT DISTINCT durability_days FROM spare_part WHERE durability_days IS NOT NULL AND durability_days > 0 ORDER BY durability_days ASC") { cursor ->
    cursor.getLong(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insert(
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    reference: String?,
  ): Long {
    val result = driver.execute(-587_718_722, """
        |INSERT INTO spare_part (server_id, category_id, spare_part_id, brand, model, additional_info, durability_days, quantity, unit, reference)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          var parameterIndex = 0
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, category_id)
          bindString(parameterIndex++, spare_part_id)
          bindString(parameterIndex++, brand)
          bindString(parameterIndex++, model)
          bindString(parameterIndex++, additional_info)
          bindLong(parameterIndex++, durability_days)
          bindDouble(parameterIndex++, quantity)
          bindString(parameterIndex++, unit)
          bindString(parameterIndex++, reference)
        }.await()
    notifyQueries(-587_718_722) { emit ->
      emit("spare_part")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertWithId(
    id: Long?,
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    reference: String?,
  ): Long {
    val result = driver.execute(24_667_615, """
        |INSERT INTO spare_part (id, server_id, category_id, spare_part_id, brand, model, additional_info, durability_days, quantity, unit, reference)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          var parameterIndex = 0
          bindLong(parameterIndex++, id)
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, category_id)
          bindString(parameterIndex++, spare_part_id)
          bindString(parameterIndex++, brand)
          bindString(parameterIndex++, model)
          bindString(parameterIndex++, additional_info)
          bindLong(parameterIndex++, durability_days)
          bindDouble(parameterIndex++, quantity)
          bindString(parameterIndex++, unit)
          bindString(parameterIndex++, reference)
        }.await()
    notifyQueries(24_667_615) { emit ->
      emit("spare_part")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertSparePart(
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    quantity: Double?,
    unit: String?,
    durability_days: Long?,
    signature: String?,
    reference: String?,
  ): Long {
    val result = driver.execute(-982_885_044, """
        |INSERT INTO spare_part(server_id, category_id, spare_part_id, brand, model, additional_info, quantity, unit, durability_days, signature, reference)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          var parameterIndex = 0
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, category_id)
          bindString(parameterIndex++, spare_part_id)
          bindString(parameterIndex++, brand)
          bindString(parameterIndex++, model)
          bindString(parameterIndex++, additional_info)
          bindDouble(parameterIndex++, quantity)
          bindString(parameterIndex++, unit)
          bindLong(parameterIndex++, durability_days)
          bindString(parameterIndex++, signature)
          bindString(parameterIndex++, reference)
        }.await()
    notifyQueries(-982_885_044) { emit ->
      emit("spare_part")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertSparePartWithId(
    id: Long?,
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    quantity: Double?,
    unit: String?,
    durability_days: Long?,
    signature: String?,
    reference: String?,
  ): Long {
    val result = driver.execute(-2_143_436_563, """
        |INSERT OR REPLACE INTO spare_part(id, server_id, category_id, spare_part_id, brand, model, additional_info, quantity, unit, durability_days, signature, reference)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 12) {
          var parameterIndex = 0
          bindLong(parameterIndex++, id)
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, category_id)
          bindString(parameterIndex++, spare_part_id)
          bindString(parameterIndex++, brand)
          bindString(parameterIndex++, model)
          bindString(parameterIndex++, additional_info)
          bindDouble(parameterIndex++, quantity)
          bindString(parameterIndex++, unit)
          bindLong(parameterIndex++, durability_days)
          bindString(parameterIndex++, signature)
          bindString(parameterIndex++, reference)
        }.await()
    notifyQueries(-2_143_436_563) { emit ->
      emit("spare_part")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun update(
    server_id: Long?,
    category_id: String,
    spare_part_id: String,
    brand: String,
    model: String,
    additional_info: String,
    durability_days: Long?,
    quantity: Double?,
    unit: String?,
    signature: String?,
    reference: String?,
    id: Long,
  ): Long {
    val result = driver.execute(-242_772_530, """UPDATE spare_part SET server_id = ?, category_id = ?, spare_part_id = ?, brand = ?, model = ?, additional_info = ?, durability_days = ?, quantity = ?, unit = ?, signature = ?, reference = ? WHERE id = ?""", 12) {
          var parameterIndex = 0
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, category_id)
          bindString(parameterIndex++, spare_part_id)
          bindString(parameterIndex++, brand)
          bindString(parameterIndex++, model)
          bindString(parameterIndex++, additional_info)
          bindLong(parameterIndex++, durability_days)
          bindDouble(parameterIndex++, quantity)
          bindString(parameterIndex++, unit)
          bindString(parameterIndex++, signature)
          bindString(parameterIndex++, reference)
          bindLong(parameterIndex++, id)
        }.await()
    notifyQueries(-242_772_530) { emit ->
      emit("spare_part")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_by_id(id: Long): Long {
    val result = driver.execute(-1_266_748_492, """DELETE FROM spare_part WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindLong(parameterIndex++, id)
        }.await()
    notifyQueries(-1_266_748_492) { emit ->
      emit("SparePartDocument")
      emit("spare_part")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_all(): Long {
    val result = driver.execute(-1_878_412_398, """DELETE FROM spare_part""", 0).await()
    notifyQueries(-1_878_412_398) { emit ->
      emit("SparePartDocument")
      emit("spare_part")
    }
    return result
  }

  private inner class Select_by_idQuery<out T : Any>(
    public val id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spare_part", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spare_part", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(1_534_140_997, """SELECT spare_part.id, spare_part.server_id, spare_part.category_id, spare_part.spare_part_id, spare_part.brand, spare_part.model, spare_part.additional_info, spare_part.durability_days, spare_part.quantity, spare_part.unit, spare_part.signature, spare_part.reference FROM spare_part WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindLong(parameterIndex++, id)
    }

    override fun toString(): String = "SparePart.sq:select_by_id"
  }

  private inner class Select_by_server_idQuery<out T : Any>(
    public val server_id: Long?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spare_part", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spare_part", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(null, """SELECT spare_part.id, spare_part.server_id, spare_part.category_id, spare_part.spare_part_id, spare_part.brand, spare_part.model, spare_part.additional_info, spare_part.durability_days, spare_part.quantity, spare_part.unit, spare_part.signature, spare_part.reference FROM spare_part WHERE server_id ${ if (server_id == null) "IS" else "=" } ?""", mapper, 1) {
      var parameterIndex = 0
      bindLong(parameterIndex++, server_id)
    }

    override fun toString(): String = "SparePart.sq:select_by_server_id"
  }

  private inner class Select_by_categoryQuery<out T : Any>(
    public val category_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spare_part", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spare_part", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-699_020_632, """SELECT spare_part.id, spare_part.server_id, spare_part.category_id, spare_part.spare_part_id, spare_part.brand, spare_part.model, spare_part.additional_info, spare_part.durability_days, spare_part.quantity, spare_part.unit, spare_part.signature, spare_part.reference FROM spare_part WHERE category_id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, category_id)
    }

    override fun toString(): String = "SparePart.sq:select_by_category"
  }

  private inner class Select_by_spare_part_idQuery<out T : Any>(
    public val spare_part_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spare_part", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spare_part", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(736_191_509, """SELECT spare_part.id, spare_part.server_id, spare_part.category_id, spare_part.spare_part_id, spare_part.brand, spare_part.model, spare_part.additional_info, spare_part.durability_days, spare_part.quantity, spare_part.unit, spare_part.signature, spare_part.reference FROM spare_part WHERE spare_part_id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, spare_part_id)
    }

    override fun toString(): String = "SparePart.sq:select_by_spare_part_id"
  }

  private inner class Select_latest_by_category_and_type_for_vehicleQuery<out T : Any>(
    public val vehicle_vin: String,
    public val category_id: String,
    public val spare_part_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spare_part", "maintenance_spare_parts", "maintenance", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spare_part", "maintenance_spare_parts", "maintenance", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-620_546_612, """
    |SELECT sp.id, sp.server_id, sp.category_id, sp.spare_part_id, sp.brand, sp.model, sp.additional_info, sp.durability_days, sp.quantity, sp.unit, sp.signature, sp.reference FROM spare_part sp
    |INNER JOIN maintenance_spare_parts msp ON sp.id = msp.spare_part_id
    |INNER JOIN maintenance m ON msp.maintenance_id = m.id
    |WHERE m.vehicle_vin = ? 
    |  AND sp.category_id = ? 
    |  AND sp.spare_part_id = ?
    |ORDER BY m.date DESC
    |LIMIT 1
    """.trimMargin(), mapper, 3) {
      var parameterIndex = 0
      bindString(parameterIndex++, vehicle_vin)
      bindString(parameterIndex++, category_id)
      bindString(parameterIndex++, spare_part_id)
    }

    override fun toString(): String = "SparePart.sq:select_latest_by_category_and_type_for_vehicle"
  }

  private inner class Select_distinct_brands_by_typeQuery<out T : Any>(
    public val vehicle_type: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spare_part", "maintenance_spare_parts", "maintenance", "vehicle", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spare_part", "maintenance_spare_parts", "maintenance", "vehicle", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(1_646_355_988, """
    |SELECT DISTINCT sp.brand 
    |FROM spare_part sp
    |INNER JOIN maintenance_spare_parts msp ON sp.id = msp.spare_part_id
    |INNER JOIN maintenance m ON msp.maintenance_id = m.id
    |INNER JOIN vehicle v ON m.vehicle_vin = v.vin
    |WHERE v.vehicle_type = ? AND sp.brand != ''
    |ORDER BY sp.brand ASC
    """.trimMargin(), mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, vehicle_type)
    }

    override fun toString(): String = "SparePart.sq:select_distinct_brands_by_type"
  }

  private inner class Select_distinct_models_by_typeQuery<out T : Any>(
    public val vehicle_type: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("spare_part", "maintenance_spare_parts", "maintenance", "vehicle", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("spare_part", "maintenance_spare_parts", "maintenance", "vehicle", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-931_779_406, """
    |SELECT DISTINCT sp.model 
    |FROM spare_part sp
    |INNER JOIN maintenance_spare_parts msp ON sp.id = msp.spare_part_id
    |INNER JOIN maintenance m ON msp.maintenance_id = m.id
    |INNER JOIN vehicle v ON m.vehicle_vin = v.vin
    |WHERE v.vehicle_type = ? AND sp.model != ''
    |ORDER BY sp.model ASC
    """.trimMargin(), mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, vehicle_type)
    }

    override fun toString(): String = "SparePart.sq:select_distinct_models_by_type"
  }
}
